import { render, staticRenderFns } from "./PdfFileTab.vue?vue&type=template&id=67001645&scoped=true"
import script from "./PdfFileTab.vue?vue&type=script&lang=js"
export * from "./PdfFileTab.vue?vue&type=script&lang=js"
import style0 from "./PdfFileTab.vue?vue&type=style&index=0&id=67001645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67001645",
  null
  
)

export default component.exports